/**
 * Useful widget
 */

var okButtton = $('.js-useful-widget-control-ok');
var noOkButtton = $('.js-useful-widget-control-no-ok');
var questionContent = $('.js-useful-widget-question');
var okContent = $('.js-useful-widget-ok ');
var noOkContent = $('.js-useful-widget-no-ok');

if ($('.c-useful-widget').length) {
    okButtton.on('click', function () {
        console.log('asd');
        questionContent.fadeOut(function () {
            okContent.fadeIn(function () {
                $(this).find('.c-useful-widget__title').attr('tabindex', -1).focus();
            });
        });
    });
    noOkButtton.on('click', function () {
        questionContent.fadeOut(function () {
            noOkContent.fadeIn(function () {
                $(this).find('.c-useful-widget__title').attr('tabindex', -1).focus();
            });
        });
    });
}